import { FC } from 'react';
import { Header } from '@tanstack/react-table';
import { useDraggableColumnOrder } from '../columnOrder/useDraggableColumnOrder';
import { useIsResizingColumn } from '../columnSizing/useIsResizingColumn';
import { HeaderCellTemplate } from './HeaderCellTemplate';
import { useTableStoreValue } from '../TableContext';

export type HeaderCellProps = {
  header: Header<any, unknown>;
};

export const HeaderCell: FC<HeaderCellProps> = ({ header }) => {
  const [columnResizeDisabled] = useTableStoreValue('columnResizeDisabled');
  const [disableHeader] = useTableStoreValue('disableHeader');
  const { ref, isDragging, ...listeners } = useDraggableColumnOrder(header);
  const isResizingColumn = useIsResizingColumn();

  return (
    <HeaderCellTemplate
      header={header}
      appearsActive={isResizingColumn === header.id}
      appearsDisabled={isDragging}
      columnResizeDisabled={columnResizeDisabled}
      ref={ref}
      disabled={disableHeader}
      {...listeners}
    />
  );
};
